// extracted by mini-css-extract-plugin
export default {"app":"Notice_app__3AXcs","headerBar":"Notice_headerBar__mtfyq","view":"Notice_view__OlryA","item":"Notice_item__cVWiX","read":"Notice_read__lUPET"};